import React from "react";

import { Icon } from "@partials";
import { DownloadsLinksItem } from "../widgets/ExchangeRatesList/types";

type RatesDownloadsProps = {
  isVisible?: boolean;
  title?: string;
  links?: DownloadsLinksItem[];
  iconsList: any;
  apiUrl?: string;
  cultureCode?: string;
  fromDate?: string;
  toDate?: string;
  timeFrame?: string;
  currency?: string;
  isSK?: boolean;
};

const RatesDownloads: React.FC<RatesDownloadsProps> = ({
  isVisible,
  title,
  links,
  iconsList,
  apiUrl,
  cultureCode,
  fromDate,
  toDate,
  timeFrame,
  currency,
  isSK,
}) => {
  if (!isVisible) return null;

  const { download } = iconsList;

  const handleOnClick = (dataAnalytics, downloadUrl) => {
    const { dataLayer } = window;
    dataLayer.push(JSON.parse(dataAnalytics));
    window.location.href = downloadUrl;
  };

  return (
    <div className="mb-12">
      <p className="mb-6 text-2xl">{title}</p>

      {links.map((link) => {
        // /api/exchangerate/downloadexchangerates?cultureCode=cs-CZ&format=xls
        let downloadUrl = `${apiUrl}?cultureCode=${cultureCode}&format=${link.extension}`;

        if (isSK) {
          downloadUrl += `&isSK=${isSK}`;
        }

        let analyticsComponent = "";
        if (Number(timeFrame) >= 0) {
          // /api/exchangerate/downloadexchangerates?cultureCode=cs-CZ&format=xls&currency=EUR&timeFrame=8&fromDate=2023-05-29&toDate=2023-05-29
          downloadUrl += `&currency=${currency}&timeframe=${timeFrame}&fromDate=${fromDate}&toDate=${toDate}`;
          analyticsComponent = "currency-detail";
        } else {
          // /api/exchangerate/downloadexchangerates?cultureCode=cs-CZ&format=xls&date=2022-12-04T07:00:00
          downloadUrl += `&date=${fromDate}`;
          analyticsComponent = "currency-list";
        }

        const dataAnalytics = `{"event":"download.file","linkUrl":"${downloadUrl}","fileContext":{"fileName":"${link.title}","fileType":"${link.extension}","fileComponent":"${analyticsComponent}"}}`;

        return (
          <div className="mb-8 last:mb-0" key={downloadUrl}>
            <button
              type="button"
              className="group inline-flex items-center focus:outline-grey-200"
              data-testid="downloads-link"
              onClick={() => {
                handleOnClick(dataAnalytics, downloadUrl);
              }}
              data-analytics={dataAnalytics}
            >
              <div>
                <Icon
                  name={download.name}
                  viewBox={download.viewbox}
                  alt={download.alt}
                  svg={download.svg}
                  className="mr-6 inline h-8 w-8 fill-red-corporate"
                />
              </div>
              <div className="words-break text-left">
                <span className="mb-2 inline-block underline group-visited:text-visited group-hover:text-red-corporate">
                  {link.title}
                </span>
                <div>
                  <span className="mr-2 text-xs text-grey-160">{link.subTitle}</span>
                  <span className="rounded-lg bg-light px-2 py-1 text-2xs font-semibold uppercase text-grey-160 shadow-tab group-visited:text-visited group-hover:text-red-corporate">
                    {link.extension}
                  </span>
                </div>
              </div>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default RatesDownloads;
